import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { DownloadStatusPurpose } from "gql/apollo/graphql";
import { useCallback } from "react";

export const InitiateDownloadStatus = graphql(/* GraphQL */ `
	mutation InitiateDownloadStatus($params: InitiateDownloadStatusParams!) {
		initiateDownloadStatus(params: $params) {
			success
			error {
				message
				code
			}
		}
	}
`);

export function useInitiateDownloadStatus(
	purpose: DownloadStatusPurpose,
	gid?: GID
) {
	const [initiateDownloadStatus] = useMutation(InitiateDownloadStatus);

	const handleInitiateDownloadStatus = useCallback(async () => {
		if (!gid) {
			return {
				success: undefined,
				error: undefined,
			};
		}

		const result = await initiateDownloadStatus({
			variables: {
				params: {
					target_gid: gid,
					purpose,
				},
			},
		});

		return {
			success: result.data?.initiateDownloadStatus.success,
			error: result.data?.initiateDownloadStatus.error,
		};
	}, [gid, initiateDownloadStatus, purpose]);

	return { handleInitiateDownloadStatus };
}
